var map = {
	"./a-la-modes.png": 1614,
	"./beverages.png": 1615,
	"./boxes.png": 579,
	"./brownies.png": 1616,
	"./cakes.png": 1617,
	"./catering.png": 1618,
	"./cookie_magic_specials.png": 1619,
	"./cookies.png": 1620,
	"./deals.png": 1621,
	"./ice-cream.png": 1622,
	"./milkshakes.png": 1623,
	"./packs.png": 1624,
	"./wiches.png": 1625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;